import $ from 'jquery';
import 'slick-carousel';

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 * ======================================================================== */

var Sage = {
  'common': {
    init: function() {},
    finalize: function() {

      // 1. PRELOADER & INITIAL FADE-INS
      $(window).on('load', function() {
          $('#luxury-preloader').fadeOut(500, function() {
              $('.hero-inner, .fade-in-section-home, .back-link').addClass('is-visible');
              $(window).trigger('scroll');
          });
      });

      $(".mobile-nav-toggle").on("click", function(e){
          $(".mobile-navigation-container").toggleClass("opened");
          $(".overlay-nav").fadeToggle(100);
          e.preventDefault();
      });

      $(window).scroll(function() {
        if ($(window).scrollTop() > 70) {
          $(".header-bar").addClass("scrolled");
        } else {
          $(".header-bar").removeClass("scrolled");
        }
      });

      $(".fade-in-section-home").addClass("is-visible");

      $(window).scroll(function () {
        $('.fade-in-section, .fade-in-section-left, .fade-in-section-right').each(function () {
            var bottom_of_object = $(this).offset().top + ($(this).outerHeight() * 0.05);
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            if (bottom_of_window > bottom_of_object) {
                $(this).addClass('is-visible');
            }
        });
      });

      // Force trigger scroll to catch items on initial load
      setTimeout(function() {
          $(window).trigger('scroll');
      }, 100);

      $("#projectSlider, #testimonialSlider").slick({
          dots: false, infinite: true, speed: 500, slidesToShow: 1,
          adaptiveHeight: true, autoplay: false, arrows: true,
          prevArrow: "<a href='#' class='slick-prev'><span class='fa fa-chevron-left'></span></a>",
          nextArrow: "<a href='#' class='slick-next'><span class='fa fa-chevron-right'></span></a>",
      });
    }
  },
  
  // Home & Contact page forms
  'contact': {
    init: function() {},
    finalize: function() {
      $("#emailAddress").on('keyup blur input keydown change', function(){
           var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
           var email = $(this).val();
           if(emailPattern.test(email)){
              $("#emailAddress").addClass("valid").removeClass("error");
              $("#emailAddress").parent().find(".error-message").remove();
           }else{
              $("#emailAddress").removeClass("valid").addClass("error");
           }
      });

      $("#phoneNumber").on('keyup blur input keydown change', function(){
           var phonePattern = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
           var phone = $(this).val();
           if(phonePattern.test(phone)){
              $("#phoneNumber").addClass("valid").removeClass("error");
              $("#phoneNumber").parent().find(".error-message").remove();
           }else{
              $("#phoneNumber").removeClass("valid").addClass("error");
           }
      });

      $("#fullName").on('keyup blur input', function(){
        var name = $(this).val();
          if (name.length >= 2) {
            $(this).removeClass("error").addClass("valid");
            $(this).parent().find(".error-message").remove();
          }else{
             $(this).removeClass("valid").addClass("error");
          }
      });

      $("#contactMessage").on('keyup blur input', function(){
        var name = $(this).val();
          if (name.length >= 2) {
            $(this).removeClass("error").addClass("valid");
            $(this).parent().find(".error-message").remove();
          }else{
             $(this).removeClass("valid").addClass("error");
          }
      });

      $(".btn-submit").on("click", function(e){
          e.preventDefault();
          $(this).attr("disabled", true);
          var validCount = 0;

         if($("#fullName").hasClass("valid")){ validCount++; } else {
            $("#fullName").parent().find(".error-message").remove();
            $("#fullName").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Your full name is required.</span>");
         }

         if($("#emailAddress").hasClass("valid")){ validCount++; } else {
            $("#emailAddress").parent().find(".error-message").remove();
            $("#emailAddress").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Not a valid email address.</span>");
         }

         if($("#phoneNumber").hasClass("valid")){ validCount++; } else {
            $("#phoneNumber").parent().find(".error-message").remove();
            $("#phoneNumber").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Not a valid phone number.</span>");
         }

         if($("#contactMessage").hasClass("valid")){ validCount++; } else {
            $("#contactMessage").parent().find(".error-message").remove();
            $("#contactMessage").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Not an accepted message length. Try again and be more descriptive.</span>");
         }

         if(validCount > 3){ $(".contact-form")[0].submit(); } else {
              $(this).attr("disabled", false);
              return false;
         }
      });
    }
  },
  
  // Project estimate page
  'project_estimate': {
    init: function() {},
    finalize: function(){
      $("#emailAddress").on('keyup blur input keydown change', function(){
           var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
           var email = $(this).val();
           if(emailPattern.test(email)){
              $("#emailAddress").addClass("valid").removeClass("error");
              $("#emailAddress").parent().find(".error-message").remove();
           }else{
              $("#emailAddress").removeClass("valid").addClass("error");
           }
      });

      $("#phoneNumber").on('keyup blur input keydown change', function(){
           var phonePattern = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
           var phone = $(this).val();
           if(phonePattern.test(phone)){
              $("#phoneNumber").addClass("valid").removeClass("error");
              $("#phoneNumber").parent().find(".error-message").remove();
           }else{
              $("#phoneNumber").removeClass("valid").addClass("error");
           }
      });

      $("#fullName").on('keyup blur input', function(){
        var name = $(this).val();
          if (name.length >= 2) {
            $(this).removeClass("error").addClass("valid");
            $(this).parent().find(".error-message").remove();
          }else{
             $(this).removeClass("valid").addClass("error");
          }
      });

      $("#contactMessage").on('keyup blur input', function(){
        var name = $(this).val();
          if (name.length >= 2) {
            $(this).removeClass("error").addClass("valid");
            $(this).parent().find(".error-message").remove();
          }else{
             $(this).removeClass("valid").addClass("error");
          }
      });

      $(".btn-submit").on("click", function(e){
          e.preventDefault();
          $(this).attr("disabled", true);
          var validCount = 0;

         if($("#fullName").hasClass("valid")){ validCount++; } else {
            $("#fullName").parent().find(".error-message").remove();
            $("#fullName").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Your full name is required.</span>");
         }

         if($("#emailAddress").hasClass("valid")){ validCount++; } else {
            $("#emailAddress").parent().find(".error-message").remove();
            $("#emailAddress").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Not a valid email address.</span>");
         }

         if($("#phoneNumber").hasClass("valid")){ validCount++; } else {
            $("#phoneNumber").parent().find(".error-message").remove();
            $("#phoneNumber").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Not a valid phone number.</span>");
         }

         if($("#contactMessage").hasClass("valid")){ validCount++; } else {
            $("#contactMessage").parent().find(".error-message").remove();
            $("#contactMessage").addClass("error").parent().append("<span class='text-danger error-message'><span class='fa fa-exclamation-triangle'></span> Not an accepted message length. Try again and be more descriptive.</span>");
         }

         if(validCount > 3){ $(".contact-form")[0].submit(); } else {
              $(this).attr("disabled", false);
              return false;
         }
      });
    }
  }
};

var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Sage;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('common');
    $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
      UTIL.fire(classnm);
      UTIL.fire(classnm, 'finalize');
    });
    UTIL.fire('common', 'finalize');
  }
};

$(document).ready(UTIL.loadEvents);


// ========================================================================
// PORTFOLIO FILTERING & MAP LOGIC
// Extracted from Sage routing to guarantee execution on element presence
// ========================================================================
$(document).ready(function() {
    
    // --- 1. Portfolio Master Filtering ---
    if ($('.premium-controls').length > 0) {
        $('.filter-link').on('click', function(e) {
            e.preventDefault();
            $('.filter-link').removeClass('active');
            $(this).addClass('active');
            applyProjectFilters();
        });

        $('#projectSearchInput').on('keyup input', function() {
            applyProjectFilters();
        });

        function applyProjectFilters() {
            var filterValue = $('.filter-link.active').attr('data-filter') || 'all';
            var searchValue = ($('#projectSearchInput').val() || '').toLowerCase().trim();

            $('.editorial-card').each(function() {
                var $card = $(this);
                var categories = $card.attr('data-categories') || '';
                var catArray = categories.split(' ');
                var title = ($card.attr('data-title') || '').toLowerCase();
                
                var matchesCategory = (filterValue === 'all' || $.inArray(filterValue, catArray) !== -1);
                var matchesSearch = (searchValue === '' || title.indexOf(searchValue) !== -1);

                if (matchesCategory && matchesSearch) {
                    $card.show();
                    setTimeout(function() {
                        $card.addClass('is-visible');
                    }, 20); 
                } else {
                    $card.hide().removeClass('is-visible');
                }
            });
            
            // Re-trigger scroll animations for elements entering view
            setTimeout(function() {
                $(window).trigger('scroll');
            }, 100);
        }
    }

    // --- 2. Single Project Map Auto-Geocoding ---
    if ($('#project-map').length > 0 && typeof L !== 'undefined') {
        var mapEl = document.getElementById('project-map');
        var address = mapEl.getAttribute('data-address');
        
        if(address) {
            $.getJSON('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(address), function(data) {
                if(data && data.length > 0) {
                    var lat = data[0].lat;
                    var lon = data[0].lon;
                    
                    var map = L.map('project-map', { scrollWheelZoom: false }).setView([lat, lon], 14);
                    
                    // Luxury minimalist map tile
                    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
                        attribution: '&copy; OpenStreetMap &copy; CARTO'
                    }).addTo(map);
                    
                    L.marker([lat, lon]).addTo(map);
                } else {
                    $(mapEl).parent().hide();
                }
            }).fail(function() {
                $(mapEl).parent().hide();
            });
        }
    }
});